module.exports = __webpack_public_path__ + "static/media/loader.e1804e9f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loader.gif
// module id = 589
// module chunks = 1